import {setCookies, getCookies} from '@/utils/cookies'
const system = {
  state: {
    showLoader: false,
    navigationDrawerShow: getCookies('drawerStatus'),
    loaderMessage: '',
    showAlert: false,
    alertMessage: '',
    alertColor: '',
    companyLogo: '',
    systemTopBarColor: 'primary',
    localRepoPath: '',
    menuList: [],
    liveServerUrl: '',
    uploadProgressValue: 0,
    downloadFileMessage: '',
    showDownloadLoader: false,
    cancelDownloadRequestSource: null,
    showUploadLoader: false,
    uploadFileMessage: ''
  },

  mutations: {
    SET_SERVER_URL: (state, url) => {
      state.liveServerUrl = url
    },
    SET_SHOW_LOADER: (state, loaderObj) => {
      state.showLoader = loaderObj.status
      state.loaderMessage = loaderObj.message
    },
    SET_SHOW_ALERT: (state, alertObj) => {
      state.showAlert = alertObj.showAlert
      state.alertMessage = alertObj.message
      state.alertColor = alertObj.color
    },
    SET_COMPANY_LOGO: (state, url) => {
      state.companyLogo = url
    },
    SET_TOPBAR_COLOR: (state, color) => {
      state.systemTopBarColor = color
    },
    SET_MENULIST: (state, menuList) => {
      state.menuList = menuList
    },
    SET_LOCALREPOPATH: (state, localRepoPath) => {
      state.localRepoPath = localRepoPath
    },
    SET_UPLOAD_LOADER: (state, status) => {
      state.showUploadLoader = status
    },
    SET_CANCEL_REQUEST: (state, cancelSource) => {
      state.cancelDownloadRequestSource = cancelSource
    },
    SET_DOWNLOAD_MESSAGE: (state, message) => {
      state.downloadFileMessage = message
    },
    SET_UPLOAD_MESSAGE: (state, message) => {
      console.log('Message 1', message)
      state.uploadFileMessage = message
    },
    SET_UPLOAD_PROGRESS: (state, value) => {
      state.uploadProgressValue = value
    },
    SET_SHOW_NAVIGATIONDRAWERSHOW: (state, navigationDrawer) => {
      state.navigationDrawerShow = navigationDrawer
      setCookies('drawerStatus', navigationDrawer)
    }
    // SET_SHOW_ALERT: (state, alertObj) => {
    //   state.showAlert = alertObj.showAlert
    //   state.alertMessage = alertObj.message
    //   state.alertColor = alertObj.color
    // }
  },
  actions: {
    SetLiveServerUrl ({commit}, url) {
      commit('SET_SERVER_URL', url)
    },
    SetLoader ({commit}, loaderObj) {
      commit('SET_SHOW_LOADER', loaderObj)
    },
    SetAlert ({commit}, alertObj) {
      commit('SET_SHOW_ALERT', alertObj)
    },
    // SetAlert ({commit}, alertObj) {
    //   commit('SET_SHOW_ALERT', alertObj)
    // },
    SetCompanyLogo ({commit}, url) {
      commit('SET_COMPANY_LOGO', url)
    },
    SetTopBarColor ({commit}, color) {
      commit('SET_TOPBAR_COLOR', color)
    },
    SetMenuList ({commit}, menuList) {
      commit('SET_MENULIST', menuList)
    },
    SetLocalRepoPath ({commit}, localRepoPath) {
      commit('SET_LOCALREPOPATH', localRepoPath)
    },
    SetUploadProgressValue ({commit}, value) {
      commit('SET_UPLOAD_PROGRESS', value)
    },
    SetDownloadMessage ({commit}, message) {
      commit('SET_DOWNLOAD_MESSAGE', message)
    },
    SetDownloadLoader ({commit}, status) {
      commit('SET_DOWNLOAD_LOADER', status)
    },
    SetUploadMessage ({commit}, message) {
      commit('SET_UPLOAD_MESSAGE', message)
    },
    SetUploadLoader ({commit}, status) {
      commit('SET_UPLOAD_LOADER', status)
    },
    CancelDownloadRequest ({commit}, cancelSource) {
      commit('SET_CANCEL_REQUEST', cancelSource)
    },
    SetnavigationDrawer ({commit}, navigationDrawer) {
      commit('SET_SHOW_NAVIGATIONDRAWERSHOW', navigationDrawer)
    }
  }
}

export default system



// WEBPACK FOOTER //
// ./src/store/modules/system.js